import $ from "jquery"
import BaseReportPDFDefinitionBuilder from "../BaseReportPDFDefinitionBuilder";
import {ColumnsConfig} from "../../reports/overtimeReport/ColumnsConfig";
import {styles, tableLayouts} from "../BaseReportPDFDefinitionBuilder"

export default class PDFDefinitionBuilder extends BaseReportPDFDefinitionBuilder {
    init(paperOrientation, paperSize, columnStrategies, headerRowsNumber, reportParams)
    {
        BaseReportPDFDefinitionBuilder.prototype.init.call(this, paperOrientation, paperSize, columnStrategies, headerRowsNumber);
        this.reportParams = reportParams;
        return this;
    }

    getAdditionalStyles()
    {
        return styles;
    }

    getAdditionalParameters()
    {
        return parameters;
    }

    getAdditionalTableLayouts()
    {
        var layout = $.extend(true, {}, tableLayouts);
        if (this.reportParams.columnsConfig === ColumnsConfig.TIME_BALANCE_AND_OVERTIME){
            if (this.reportParams.showWorkingAndLeaveTime === true){
                layout.reportLayout.vLineWidth = this.timeBalanceAndOvertimeShowWorkingAndLayoutLineWidth;
            }else{
                layout.reportLayout.vLineWidth = this.timeBalanceAndOvertimeLayoutLineWidth;
            }
        }
        if (this.reportParams.columnsConfig === ColumnsConfig.TIME_BALANCE_ONLY
            && this.reportParams.showWorkingAndLeaveTime === true){
            layout.reportLayout.vLineWidth = this.timeBalanceOnlyShowWorkingAndLeaveLayoutLineWidth;
        }
        return layout;
    }

    timeBalanceAndOvertimeShowWorkingAndLayoutLineWidth(i, node) {
        if (i === 3 || i === 4) {
            return 0;
        }
        return (i === 1 || i === node.table.widths.length - 2) ? 2 : 1;
    }

    timeBalanceAndOvertimeLayoutLineWidth(i, node) {
        return (i === 1 || i === node.table.widths.length - 2) ? 2 : 1;
    }

    timeBalanceOnlyShowWorkingAndLeaveLayoutLineWidth(i) {
        return (i === 3 || i === 4) ? 0 : 1;
    }
}

const parameters = {
    dataTableStyles: {
        tableStyle: 'reportRow'
    },

    Portrait: {
        reportParams:
        {
            maxUserNameLen: 16,
            maxUserNameLenWide: 22
        },
        columnWidth: {
            levels: 26,
            levelsWide: 40,
            overtime: 19,
            allColumnsOvertimeReported: 10,
            allColumnsOvertimeAuto: 14,
            overtimeWide: 30,
            timeBalance: 12,
            timeBalanceAll: 10,
            timeBalanceWide: 20
        },
        A4: {
            limitOfLinesInTextCell: 62
        },
        Letter: {
            limitOfLinesInTextCell: 56
        }
    },
    Landscape: {
        reportParams:
        {
            maxUserNameLen: 22,
            maxUserNameLenWide: 32
        },
        columnWidth: {
            levels: 26,
            levelsWide: 40,
            overtime: 19,
            allColumnsOvertimeReported: 10,
            allColumnsOvertimeAuto: 14,
            overtimeWide: 30,
            timeBalance: 12,
            timeBalanceAll: 10,
            timeBalanceWide: 20
        },
        A4: {
            limitOfLinesInTextCell: 40
        },
        Letter: {
            limitOfLinesInTextCell: 42
        }
    }
};


// WEBPACK FOOTER //
// ./web/js/pdf/overtimeReport/PDFDefinitionBuilder.js